<template>
    <div>
        <BaseModal 
            v-if="visible"
            ModalId="modalId"
            :HideModalFun="onHidden"
            :TitleWindow="$t('Shared.ItemsRelocation')"
            :width="'50%'"
            :height="'auto'"
            @ShownModal="ShownModal"
            :buttons="[
                { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                { text: $t('Shared.Save'), variant: 'primary', action: emitEventOK },                   
            ]"              
            @Close="close"
        >
        <!--
            <b-row>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="this.$tc('Shared.DrugName',1)"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'drugName'"
                        v-model="value.drugName"
                        v-bind:isReadOnly="true"
                        v-bind:Id="'input_drugName'">                                     
                    </MdEdit>
                </b-col>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="this.$t('DrugOrderItemsRemoval.Ingredient')"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'activeIngred'"
                        v-model="value.activeIngred"
                        v-bind:isReadOnly="true"
                        v-bind:Id="'input_activeIngred'">                                     
                    </MdEdit>
                </b-col>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="this.$t('Shared.ExpirationDate')"
                        v-bind:TypeProp="'date'" 
                        v-bind:Name="'expirationDate'"
                        v-model="value.expirationDate"
                        v-bind:isReadOnly="true"
                        v-bind:Id="'input_expirationDate'">                                     
                    </MdEdit>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="this.$t('Shared.LotNo')"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'lotNo'"
                        v-model="value.lotNo"
                        v-bind:isReadOnly="true"
                        v-bind:Id="'input_lotNo'">                                     
                    </MdEdit>
                </b-col>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="this.$t('Shared.Location')"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'location'"
                        v-model="value.location"
                        v-bind:isReadOnly="true"
                        v-bind:Id="'input_location'">                                     
                    </MdEdit>
                </b-col>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="this.$t('Shared.Filled')"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'qtyFilled'"
                        v-model="value.qtyFilled"
                        v-bind:isReadOnly="true"
                        v-bind:Id="'input_qtyFilled'">                                     
                    </MdEdit>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="this.$t('Shared.Received')"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'qtyReceived'"
                        v-model="value.qtyReceived"
                        v-bind:isReadOnly="true"
                        v-bind:Id="'input_qtyReceived'">                                     
                    </MdEdit>
                </b-col>
                <b-col lg="4" md="4" sm="12">
                    <MdEdit 
                        v-bind:Label="this.$t('Shared.Available')"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'qtyAvailable'"
                        v-model="value.qtyAvailable"
                        v-bind:isReadOnly="true"
                        v-bind:Id="'input_qtyAvailable'">                                     
                    </MdEdit>
                </b-col>
            </b-row>
        -->


            <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdEdit 
                        v-bind:Label="$t('DrugOrderItemsRelocation.QuantityToRelocate')"
                        v-bind:TypeProp="'number'" 
                        v-bind:Name="'qtyToMove'"
                        v-bind:Min="'0'"
                        v-bind:StepProp="'1'"
                        v-model="value.qtyToMove"
                        v-bind:isRequired="true"
                        :isValid="isValid('qtyToMove')"
                        v-bind:Id="'input_qtyToMove'">                                     
                    </MdEdit>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                        v-bind:Label="$t('DrugOrderItemsRelocation.LocationTo')"
                        v-bind:Options="locationsFiltered"
                        v-bind:ModelArray="locationVModel"
                        v-bind:FieldDescription="'name'"
                        v-bind:FieldCode="'code'"
                        :isValid="isValid('locationTo')"
                        v-bind:isRequired="true"
                        :Input="changeDropDownLocation"/>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdEdit 
                        v-bind:Label="$t('DrugOrderItemsRelocation.RequisitionNumber')"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'requisitionNumber'"
                        v-model="value.requisitionNumber"
                        v-bind:Id="'input_requisitionNumber'">                                     
                    </MdEdit>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdEdit 
                        v-bind:Label="$t('Shared.Remarks')"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'notes'"
                        v-model="value.notes"
                        v-bind:Id="'input_notes'">                                     
                    </MdEdit>
                </b-col>
            </b-row>
           <div class="grid-margin stretch-card mt-3">
			<div class="card activeCard">
			<div class="card-body">	     
			<div class="d-flex align-items-start justify-content-between">
				<h6 v-b-toggle="'ItemRelocationInfo'" class="card-title flex-grow lower-line text-truncate"> {{this.$t('DrugOrderItemsRelocation.ItemsRelocationInfo')}}</h6>      
			</div>

			<div class="float-left col-md-4 text-muted p-item">
				<small>{{this.$tc('Shared.DrugName',1)}}</small><br>
				<b>{{value.drugName}}</b>        
			</div>

			<div class="float-left col-md-4 text-muted p-item">
				<small>{{this.$t('Shared.activeIngredients')}}</small><br>
				<b>{{value.activeIngred}}</b>
			</div>


             <div class="float-left col-md-2 text-muted p-item">
				<small>{{ this.$t('Shared.Location') }}</small><br>
				<b>{{value.locationName}}</b>
			</div>

			<div class="float-left col-md-2 text-muted p-item">
				<small>{{ this.$t('Shared.ExpirationDate') }}</small><br>
				<b>{{value.expirationDate}}</b>
                <!--<b>
                <span 
                    :class="{ 'text-danger': new Date(value.expirationDate) < new Date() }"> {{ formatDate(value.expirationDate) }}
                </span>  
                </b>-->
			</div>

            <div class="float-left col-md-4 text-muted p-item">
				<small>{{ this.$t('Shared.LotNo') }}</small><br>
				<b>{{value.lotNo}}</b>
			</div>
            
            <div class="float-left col-md-4 text-muted p-item">
				<small>{{ this.$t('Shared.Filled') }}</small><br>
				<b>{{value.qtyFilled}}</b>
			</div>
            <div class="float-left col-md-2 text-muted p-item">
				<small>{{ this.$t('Shared.Received') }}</small><br>
				<b>{{value.qtyReceived}}</b>
			</div>
            <div class="float-left col-md-2 text-muted p-item">
				<small>{{ this.$t('Shared.Available') }}</small><br>
				<b>{{value.qtyAvailable}}</b>
			</div>
			</div>
		</div>		
            </div>           
        </BaseModal>
    </div>
</template>

<script>
import validationMixin from '@/common/validationMixin';
import validationRules from '@/common/validationRules';
import Utils from '@/common/utils'
import ShowMessage from '@/components/messages/ShowMessage.js';

export default {
    name: 'DrugOrderItemsRelocationEditDlg',
    mixins: [validationMixin, ShowMessage],

    props: {
        value: Object,
        visible: {
            type: Boolean,
            default: false
        },
        locations: Array
    },

    data() {
        return {
            modalId: 'ItemsRemovalEditDlgId',
            locationVModel: null,
            emitCloseEvent: false
        }
    },

    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent= true;
            }
        },
    },

    computed: {
        locationsFiltered() {
            if (this.value) {
                return this.locations.filter(x => x.code.toLowerCase() !== this.value.location.toLowerCase());
            }

            return this.locations;
        }
    },

    methods: {
        emitEventCancel() {
            this.emitCloseEvent= false;
            this.$emit('close');
        },

        ShownModal(){
             this.$nextTick(()=>{
                const el = document.getElementById("input_qtyToMove");
                if(el) el.focus();
            })
        },

        formatDate(value){
            return Utils.formatterDateToString(value)
        },

        emitEventOK(bvModalEvent) {
            if (this.validate()) {
                this.$emit('ok');
            } else {
                bvModalEvent.preventDefault();

                if (!this.isValid('locationTo')) {
                    this.showMessage(this.$tc('Msg.Error'),this.invalidMessage('locationTo'),"errorAutoHide"); 
                }
                if (!this.isValid('qtyToMove')) {
                    this.showMessage(this.$tc('Msg.Error'),this.invalidMessage('qtyToMove'),"errorAutoHide"); 
                }
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('close');
                this.emitCloseEvent= false;
            }
        },

        validate() {
            const rules = {
                locationTo: [
                    validationRules.required(
                        this.$t("DrugOrderItemsRelocation.LocationRequired")
                    ),
                    validationRules.notEqual(this.value.location,
                        this.$t("DrugOrderItemsRelocation.LocationNotEqual")
                    ),
                ],
                qtyToMove: [
                    validationRules.required(
                        this.$t("DrugOrderItemsRelocation.QuantityToRelocateRequired")
                    ),
                    validationRules.greaterThan(0,
                        this.$t("DrugOrderItemsRelocation.QuantityToRelocateZero")
                    ),
                    validationRules.max(+this.value.qtyAvailable,
                        this.$t("DrugOrderItemsRelocation.QuantityToRelocateAvailable")
                    ),
                ],
            }

            return this.validateFields(rules, this.value);
        },

        changeDropDownLocation(value) {
            this.value.locationTo = value ? value.code : null;
        },

        close() {
            this.emitEventCancel();
        }
    }
}
</script>
